import { VipType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';

/** 时间格式补 0, 服务端返回的时间格式是 秒级 的 */
export const formatTime = (timestamp: number) => {
    const d = new Date(timestamp * 1000);
    const month = d.getMonth() + 1;
    const date = d.getDate();
    const hour = d.getHours();
    const min = d.getMinutes();

    const r: Array<string> = [month, date, hour, min].map((t: number) => (t < 10 ? `0${t}` : t.toString()));
    return `${r[0]}-${r[1]} ${r[2]}:${r[3]}`;
};

export enum VipLevel  {
    NONE,
    EXPIRED,
    NORMAL,
    SUPER,
}

export function getVipTypeFromLevel(vipLevel: number | undefined) {
    switch (vipLevel) {
        case VipLevel.NORMAL:
            return VipType.NORMAL;
        case VipLevel.SUPER:
            return VipType.SUPER;
        default:
            return VipType.NONE;
    }
}
